import React from "react";

const PageBody = ({ children, style }) => {
  return (
    <div>
      {children}
    </div>
  );
};

export default PageBody;

